export default "__VITE_PUBLIC_ASSET__d9ef5a38__"